/** Čisti izračun napretka upisa zalihe iz liste poslova, da ga i hook (za polling) i
 *  stranica (za brojač/spinner) dijele bez duplanja logike. Worker obrađuje poslove
 *  sekvencijalno, pa je "aktivan" prvi koji je još `pending`. */
export type StockJobLike = { id: string; status: string };

export type StockProgress = {
  total: number;
  done: number;
  failed: number;
  pending: number;
  /** true dok ijedan posao čeka — signal za polling i za prikaz brojača/spinnera. */
  active: boolean;
  /** id posla koji se trenutno obrađuje (prvi `pending` po redu), ili null. */
  activeId: string | null;
};

export function stockProgress(jobs: StockJobLike[] | undefined | null): StockProgress {
  const list = jobs ?? [];
  let done = 0;
  let failed = 0;
  let activeId: string | null = null;
  for (const j of list) {
    if (j.status === "done") done++;
    else if (j.status === "failed") failed++;
    else if (activeId === null) activeId = j.id; // prvi neposložen (pending) = trenutni
  }
  const pending = list.length - done - failed;
  return { total: list.length, done, failed, pending, active: pending > 0, activeId };
}

/** Interval osvježavanja za React Query: prati dok traje upis, pa stane. */
export function stockRefetchInterval(jobs: StockJobLike[] | undefined | null): number | false {
  return stockProgress(jobs).active ? 1000 : false;
}
